<template>
  <div class="px-6 py-6 divide-y divide-gray-200">
    <div class="flex justify-end">
      <slot />
    </div>
  </div>
</template>
